export var STEP;
(function (STEP) {
    STEP["CHOOSE_VIDEO"] = "CHOOSE_VIDEO";
    STEP["CHOOSE_TEMPLATE"] = "CHOOSE_TEMPLATE";
    STEP["SELECT_SUBTITLES"] = "SELECT_SUBTITLES";
    STEP["EDIT_SUBTITLES"] = "EDIT_SUBTITLES";
    STEP["DOWNLOAD"] = "DOWNLOAD";
    STEP["PREVIEW"] = "PREVIEW";
    STEP["HIGHLIGHT_SUBTITLE"] = "HIGHLIGHT_SUBTITLE";
    STEP["SELECT_INTRO"] = "SELECT_INTRO";
    STEP["RECAP_PREVIEW"] = "RECAP_PREVIEW";
    STEP["RENDER"] = "RENDER";
    STEP["TEST"] = "TEST";
    STEP["SETTINGS"] = "SETTINGS";
    STEP["SAVE"] = "SAVE";
    STEP["MAINTENANCE"] = "MAINTENANCE";
    STEP["ADMIN"] = "ADMIN";
    STEP["ANALYTICS"] = "ANALYTICS";
    STEP["BRANDKIT"] = "BRANDKIT";
})(STEP || (STEP = {}));
export var MENU;
(function (MENU) {
    MENU["CLIPS"] = "Clips";
    MENU["DISCUSSION_GUIDE"] = "Discussion Guide";
    MENU["BLOG"] = "Blog";
    MENU["TRANSCRIPTION"] = "Transcription";
    MENU["AUDIO"] = "Audio";
    MENU["SUMMARIES"] = "Summaries";
    MENU["UPGRADE_PLAN"] = "Upgrade Plan";
    MENU["DEVOTIONALS"] = "Devotionals";
    MENU["QUOTES"] = "Quotes";
    MENU["RECAP"] = "Recap";
    MENU["THUMBNAILS"] = "Sermon Images";
    MENU["CAROUSEL"] = "Carousel Idea Generator";
})(MENU || (MENU = {}));
export var ProcessState;
(function (ProcessState) {
    ProcessState["INFO"] = "INFO";
    ProcessState["ERROR"] = "ERROR";
    ProcessState["WARNING"] = "WARNING";
    ProcessState["SUCCESS"] = "SUCCESS";
    ProcessState["BUSY"] = "BUSY";
})(ProcessState || (ProcessState = {}));
export var Features;
(function (Features) {
    Features["CLIPS"] = "clips";
    Features["TRANSCRIPTION"] = "transcription";
    Features["AUDIO"] = "audio";
    Features["DISCUSSION_GUIDE"] = "discussion-guide";
    Features["SUMMARY"] = "summary";
    Features["BLOG"] = "blog";
    Features["THUMBNAIL"] = "thumbnail";
    Features["LIVESTREAM"] = "livestream";
    Features["SERMON_RECAP"] = "sermon-recap";
    Features["SERMON_SHARE"] = "sermon-share";
    Features["SERMON_LIVE"] = "sermon-live";
    Features["CAROUSEL"] = "carousel";
})(Features || (Features = {}));
export var UploadSource;
(function (UploadSource) {
    UploadSource["YOUTUBE"] = "youtube";
    UploadSource["LOCAL"] = "local";
    UploadSource["LIVESTREAM"] = "stream";
    UploadSource["VIMEO"] = "vimeo";
    UploadSource["FACEBOOK"] = "facebook";
    UploadSource["GOOGLEDRIVE"] = "google-drive";
    UploadSource["DROPBOX"] = "dropbox";
    UploadSource["RESI"] = "resi";
})(UploadSource || (UploadSource = {}));
